import { useMemo } from 'react';
import {
  ProjectTemplateSpaceData,
  ProjectTemplateSpaceEnumType,
} from '../types';
import { useProjectTemplateSpaces } from './use-get-all-spaces';

export const useSpaceTabularData = (): ProjectTemplateSpaceData[] => {
  const projectSpaces = useProjectTemplateSpaces();

  return useMemo(() => {
    return Object.values(projectSpaces).map((space, index) => {
      return {
        key: `PROJECT_SPACE-${space.spaceId}`,
        id: space.spaceId,
        title: space.spaceName,
        type: ProjectTemplateSpaceEnumType.ProjectSpaceValue,
        private: space.private,
        level: 0,
        data: space,
        rootIndex: index,
        parentTotal: 0,
        parentId: 0,
        conditionRequired: true,
        children: space.spaceTabs.map((spaceTab) => {
          return {
            key: `PROJECT_SPACE_TAB-${spaceTab.spaceTabId}`,
            id: spaceTab.spaceTabId,
            title: spaceTab.spaceTabTitle,
            type: ProjectTemplateSpaceEnumType.SpaceTabValue,
            parentTotal: space.spaceTabs.length,
            parentId: space.spaceId,
            level: 1,
            data: spaceTab,
            private: space.private,
            conditionRequired: true,
          };
        }),
      };
    });
  }, [projectSpaces]);
};
